import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Passcode from "@/pages/Passcode";
import Portfolio from "@/pages/Portfolio";
import Vault from "@/pages/Vault";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Passcode />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/vault" element={<Vault />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{
        style: { background: "#0A0A0C", border: "1px solid rgba(255,255,255,0.08)", color: "#F4F4F5", fontFamily: "JetBrains Mono, monospace", fontSize: "12px", letterSpacing: "0.05em" }
      }} />
    </div>
  );
}

export default App;
